import { render, staticRenderFns } from "./AnswerDetail.vue?vue&type=template&id=123da28f&scoped=true&"
import script from "./AnswerDetail.vue?vue&type=script&lang=js&"
export * from "./AnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetail.vue?vue&type=style&index=0&id=123da28f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123da28f",
  null
  
)

export default component.exports